<template>
  <div>
    <p class="product_description_text" v-html="getProductDescription"></p>
    <p></p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("product", ["getProductDescription"])
  }
};
</script>

<style lang="scss" scoped>
.product_description_text {
  color: $darkgray;
  letter-spacing: 0.2px;
  line-height: 24px;
  font-family: $body;
  font-size: 16px;

  @include media-breakpoint-up(lg) {
    letter-spacing: 0;
    line-height: 30px;
    font-size: 20px;
  }

  &::v-deep a {
    font-family: $body;
    font-size: 16px;
    color: $primary;
    text-decoration: underline;

    @include media-breakpoint-up(lg) {
      letter-spacing: 0;
      line-height: 30px;
      font-size: 20px;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &::v-deep p {
    margin: 20px 0 0;

    &:first-child {
      margin: 0;
    }

    a {
      font-family: $body;
      font-size: 16px;
      color: $primary;
      text-decoration: underline;

      @include media-breakpoint-up(lg) {
        letter-spacing: 0;
        line-height: 30px;
        font-size: 20px;
      }
    }

    @include media-breakpoint-up(lg) {
      a:hover {
        text-decoration: underline;
      }
    }
  }
  &::v-deep ol {
    padding-left: 36px;
    li {
      display: list-item;
      list-style-type: decimal;
    }
  }
  &::v-deep ul {
    padding-left: 36px;
    li {
      display: list-item;
      list-style-type: disc;

      a {
        font-family: $body;
        font-size: 16px;
        color: $primary;
        text-decoration: underline;

        @include media-breakpoint-up(lg) {
          letter-spacing: 0;
          line-height: 30px;
          font-size: 20px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
